import { useState } from "react"
import { DollarSign, Stethoscope, Calendar, Clock } from "lucide-react"
import {
  PaymentDetailsModal, SchedulingModal,
  TreatmentDetailsModal, ActivityCard
} from "components/TreatmentPlan"
import { getPercentage, getRemainingAmount } from "./helper"

const ProgressAndActivityCard = ({ treatmentPlan }) => {
  let { scheduling, completed_treatments, treatments, payment_state, paid_amount,
    amount_to_pay, active_treatment_plan_progress, payable } = treatmentPlan || {}

  const [openedModal, setOpenedModal] = useState(null)
  const [schedulingCount, setSchedulingCount] = useState(scheduling)

  const handleSchedulingCount = (_schedulingCount: 1 | -1) =>
    setSchedulingCount((prev) => Math.min(1, Math.max(0, prev + _schedulingCount)))

  return (
    <div>
      <div className="space-y-3">
        <h1 className="text-sm font-semibold text-secondary-900 mt-2 leading-snug">Progress & Activity</h1>

        {!payable && active_treatment_plan_progress?.data &&
          <ActivityCard
            onClick={() => setOpenedModal('scheduling')}
            icon={<Calendar size={18} />}
            iconContainerClass="bg-green-100 text-green-700"
            title="Scheduling"
          >
            <div className="flex items-center gap-1 text-secondary-500 mt-1">
              <Clock size={14} strokeWidth={2} />
              <p className="text-xs text-secondary-500">{schedulingCount} appointments scheduled</p>
            </div>
          </ActivityCard>
        }

        <ActivityCard
          onClick={() => setOpenedModal("payment")}
          icon={<DollarSign size={18} />}
          iconContainerClass="bg-green-100 text-green-700"
          title="Payment"
        >
          <p className="text-md text-secondary-900 mt-1 font-semibold">
            {getRemainingAmount(payment_state, amount_to_pay, paid_amount)} remaining
          </p>
        </ActivityCard>

        <ActivityCard
          onClick={() => setOpenedModal('treatment')}
          icon={<Stethoscope size={18} />}
          iconContainerClass="bg-blue-100 text-blue-600"
          title="Treatment"
        >
          <p className="text-xs text-secondary-500 mt-0.5">
            <span className="text-lg font-semibold text-secondary-900">
              {getPercentage(treatments?.data.length, completed_treatments)}%
            </span> {completed_treatments}/{treatments?.data.length} completed
          </p>
        </ActivityCard>
      </div>

      <PaymentDetailsModal
        isOpen={openedModal == 'payment'}
        onClose={() => setOpenedModal(null)}
        treatmentPlan={treatmentPlan}
      />

      <TreatmentDetailsModal
        isOpen={openedModal == 'treatment'}
        onClose={() => setOpenedModal(null)}
        treatmentPlan={treatmentPlan}
      />

      <SchedulingModal
        isOpen={openedModal == 'scheduling'}
        onClose={() => setOpenedModal(null)}
        treatmentPlan={treatmentPlan}
        onSchedule={(_schedulingCount) => handleSchedulingCount(_schedulingCount)}
      />
    </div>
  )
}

export default ProgressAndActivityCard
